import { isScreenId, screenLabel } from '@/router/screens'
import type { AgentCopyParams, AgentLabelKey } from '@/types/chat'

/** Returns the params a label interpolates, with the `screen` of `stage.openingScreen` swapped for its translated name. */
export function agentLabelParams(
  key: AgentLabelKey,
  params: AgentCopyParams = {},
): AgentCopyParams {
  const screen = params.screen
  if (key !== 'stage.openingScreen' || typeof screen !== 'string' || !isScreenId(screen)) {
    return params
  }
  return { ...params, screen: screenLabel(screen) }
}
